<div [ngStyle]="setStyles()" class="page-canvas quote-progress-load" [ngClass]="{'quote-progress-inactive': (question?.cent_aq_question_type_id == QuestionType.quote_loader) || (question?.cent_aq_question_type_id == QuestionType.quote_screen) || (question?.cent_aq_question_type_id == QuestionType.quote_pay) || (question?.cent_aq_question_type_id == QuestionType.uw_modal) }" id="page-canvas">
  @if (partner_html && partner_type === 'full') {
    <span [innerHTML]="partner_html | safeHtml"></span>
  }

  <app-sidebar (showEditModal)="showEditModal($event)" [question]="question"></app-sidebar>

  @if (question?.location_bar > 0) {
    <div class="question-bar">
      <div class="question-bar__select">
        <div class="question-bar__select-label">
          Let's add cover to
        </div>
        <div class="dropdown dropdown--central dropdown--persist">
          <a href="#modal-traymenu-location" class="dropdown-toggle dropdown-toggle--pill d-md-none" data-toggle="modal">
            <strong id="current-location-mobile">{{selectedLocation?.location_name}}</strong>
          </a>
          <a href="#" class="dropdown-toggle dropdown-toggle--pill d-none d-md-block" data-toggle="dropdown" aria-expanded="false">
            <strong id="current-location">{{selectedLocation?.location_name}}</strong>
          </a>
          <div class="dropdown-menu dropdown-menu--checklist filter-list__scrollable">
            <div class="filter-list__content">
              <ul class="filter-list filter-list--central list-unstyled">
                @for (location of locations; track location) {
                  <li>
                    <label class="custom-input custom-input--checklist">
                      <input type="radio" [checked]="location?.location_id === selectedLocation?.location_id" (click)="setLocation(location)" value="location-a" name="location-select[]">
                      <span class="custom-input__indi">
                        <svg class="icon">
                          <use xlink:href="#success-small"></use>
                        </svg>
                      </span>
                      <span class="custom-input__label">{{location?.location_name}}</span>
                      <a href="javascript:;" (click)="CommercialEdit(location)" class="custom-input__icon">
                        <svg class="icon icon--sm">
                          <use xlink:href="#edit-underline"></use>
                        </svg>
                      </a>
                    </label>
                  </li>
                }
              </ul>
            </div>
            <div class="filter-list__add">
              <a href="javascript:;" (click)="startLocationFlow()" class="button-control button-control--tight">
                <svg class="icon">
                  <use xlink:href="#plus-filled"></use>
                  </svg><strong>Add location</strong>
                </a>
              </div>
            </div>
            <div class="guide guide--top-center guide--traffic-view-locations" id="guide-1-tip-2">
              <div class="guide__close">
                <svg class="icon">
                  <use xlink:href="#close-circle-small"></use>
                </svg>
              </div>
              <div class="guide__content">
                <p>View all your locations by simply clicking the dropdown menu.</p>
              </div>
              <div class="guide__tray">
                <div class="guide__progress">2 / 4</div>
                <div class="guide__btn">
                  <a href="#guide-1-tip-3" data-guide-btn="next" class="button button--sm button--everything">Next</a>
                </div>
              </div>
            </div>
            <div class="guide guide--top-center guide--traffic-view-locations" id="guide-3-tip-1">
              <div class="guide__close">
                <svg class="icon">
                  <use xlink:href="#close-circle-small"></use>
                </svg>
              </div>
              <div class="guide__content">
                <p>Great! Your next location has been added. View the dropdown to revist any of your locations to
                add additional cover.</p>
              </div>
              <div class="guide__tray">
                <!-- <div class="guide__progress"></div> -->
                <div class="guide__btn">
                  <a href="#" data-guide-btn="end" class="button button--sm button--everything">Got it!</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="question-bar__controls position-relative">
          <a href="javascript:;" (click)="startLocationFlow()" class="d-md-none">
            <svg class="icon">
              <use xlink:href="#plus-filled"></use>
            </svg>
          </a>
          <a href="javascript:;" (click)="startLocationFlow()" class="button button--md button--primary d-none d-md-inline-block">
            + Add location
          </a>
          <div class="guide guide--top-right guide--traffic-add-locations" id="guide-1-tip-1">
            <div class="guide__close">
              <svg class="icon">
                <use xlink:href="#close-circle-small"></use>
              </svg>
            </div>
            <div class="guide__content">
              <p>You can add as many locations as you'd like.</p>
            </div>
            <div class="guide__tray">
              <div class="guide__progress">1 / 4</div>
              <div class="guide__btn">
                <a href="#guide-1-tip-2" data-guide-btn="next" class="button button--sm button--everything">Next</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (question?.location_header && question?.cent_aq_question_type_id !== QuestionType.super_traffic_cop) {
      <div class="question-bar">
        <div class="question-bar__select">
          <div class="question-bar__select-label">{{question?.location_header}}</div>
          <!-- <strong class="question-bar__select-location">[Location A]</strong> -->
        </div>
      </div>
    }
    <main class="page-main">
      <!-- Discount Badge -->
      @if (party) {
        <div class="notify notify--confetti party">
          <div class="notify__content">
            <svg class="icon icon--md">
              <use xlink:href="#discount-summary-mini"></use>
            </svg>
            <p>Well done! <strong id="discount-badge">{{discount}}</strong> discount unlocked.</p>
          </div>
        </div>
      }
      <!-- End Discount Badge-->

      @if (question?.cent_aq_question_type_id === QuestionType.claim_security_code) {
        <app-question-security-code [question]="question"></app-question-security-code>
      }

      @if (question?.cent_aq_question_type_id === QuestionType.claim_summary_update) {
        <app-question-claim-summary-update [question]="question"></app-question-claim-summary-update>
      }
      @if (question?.cent_aq_question_type_id !== QuestionType.claim_security_code
        && question?.cent_aq_question_type_id !== QuestionType.claim_summary_update) {
        <div
          [ngClass]="(question?.cent_aq_question_type_id === QuestionType.quote_screen || question?.cent_aq_question_type_id === QuestionType.quote_pay) ? '' : 'container layout layout--questions'">
          <!-- Layout Main with Angular animations -->
          <div class="layout__main">
            @if (showAnimation) {
              <div class="layout__animator"
                [@flowAnimation]="flowAnimationParams">
                @if (question?.cent_aq_question_type_id !== QuestionType.interstitial_variation_one
                  && question?.cent_aq_question_type_id !== QuestionType.pledge
                  && question?.cent_aq_question_type_id !== QuestionType.interstitial_generic
                  && question?.cent_aq_question_type_id !== QuestionType.quote_screen
                  && question?.cent_aq_question_type_id !== QuestionType.interstitial_variation_two) {
                  <div
                    class="question-heading">
                    <div class="question-heading__avatar">
                      <img [src]="'assets/' + session_details?.category_id + '/avatar/happy.png'" class="img-fluid" alt=""/>
                    </div>
                    <div class="question-heading__content">
                      <h3 class="h4" id="{{question?.cent_aq_question_id}}" [innerHTML]="question?.question_copy"></h3>
                      <p id="sub-header" class="d-none"></p>
                    </div>
                  </div>
                }
                @if (question?.cent_aq_question_type_id === QuestionType.interstitial_variation_one) {
                  <div class="question-stepper">
                    <div class="question-stepper__img question-stepper__img--avatar">
                      <img [src]="'assets/' + session_details?.category_id + '/avatar/happy.png'" class="icon" alt=""/>
                    </div>
                    <div class="question-stepper__content">
                      <h3 class="font-normal" [innerHTML]="question?.question_copy">
                      </h3>
                    </div>
                  </div>
                  <app-question-interstitial-variation-one [question]="question"></app-question-interstitial-variation-one>
                }
                @if (question?.cent_aq_question_type_id === QuestionType.interstitial_generic) {
                  <div class="question-stepper">
                    <div class="question-stepper__img question-stepper__img--avatar">
                      <img [src]="'assets/' + session_details?.category_id + '/avatar/happy.png'" class="icon" alt=""/>
                    </div>
                    <div class="question-stepper__content">
                      <h3 class="font-normal" [innerHTML]="question?.question_copy">
                      </h3>
                    </div>
                  </div>
                  <app-question-interstitial-generic [question]="question" (questionAnswer)="activateNextButton($event)"></app-question-interstitial-generic>
                }
                @if (question?.cent_aq_question_type_id === QuestionType.interstitial_variation_two) {
                  <app-question-interstitial-screen-variation-two
                    [class_name]="class_name"
                    [session_details]="session_details"
                    [question]="question"
                    (questionAnswer)="activateNextButton($event)">
                  </app-question-interstitial-screen-variation-two>
                }
                <!--Question Pledge-->
                @if (question?.cent_aq_question_type_id === QuestionType.pledge) {
                  <div class="card card--claims">
                    <div class="card__heading">
                      <div class="card__heading-avatar">
                        <img [src]="'assets/' + session_details?.category_id + '/avatar/happy.png'" class="img-fluid" alt="">
                      </div>
                      <h3 class="font-normal" [innerHTML]="question?.question_copy"></h3>
                    </div>
                    <div class="card__body">
                      <app-question-pledge
                        [question]="question">
                      </app-question-pledge>
                    </div>
                  </div>
                }
                @if (question?.cent_aq_question_type_id === QuestionType.interstitial) {
                  <app-question-interstitial [question]="question"></app-question-interstitial>
                }
                @if (question?.cent_aq_question_type_id === QuestionType.summary
                  || question?.cent_aq_question_type_id === QuestionType.uw_page) {
                  <app-question-summary
                    [question]="question"
                    (showEditModal)="showEditModal($event)"
                    (onSummaryDataChanged)="onSummaryDataChange()"
                    (submitResponse)="submitResponse($event)"
                    (questionAnswer)="activateNextButton($event)">
                  </app-question-summary>
                }
                @if (question?.cent_aq_question_type_id === QuestionType.summary_nocalc) {
                  <app-question-summary-nocalc
                    [question]="question"
                    (showEditModal)="showEditModal($event)"
                    (onSummaryDataChanged)="onSummaryDataChange()"
                    (submitResponse)="submitResponse($event)"
                    (questionAnswer)="activateNextButton($event)">
                  </app-question-summary-nocalc>
                }
                @if (question?.cent_aq_question_type_id === QuestionType.claim_summary) {
                  <app-question-claim-summary
                    [question]="question"
                    (showEditModal)="showEditModal($event)"
                    >
                  </app-question-claim-summary>
                }
                @if (question?.cent_aq_question_type_id === QuestionType.claim_confirmation) {
                  <app-question-claim-confirmation
                    [question]="question"
                    (questionAnswer)="activateNextButton($event)">
                  </app-question-claim-confirmation>
                }
                @if (question?.cent_aq_question_type_id === QuestionType.redirect_to_url) {
                  <app-question-redirect-to-url
                    [question]="question"
                    (questionAnswer)="activateNextButton($event)">
                  </app-question-redirect-to-url>
                }
                @if (question?.cent_aq_question_type_id !== QuestionType.summary
                  && question?.cent_aq_question_type_id !== QuestionType.interstitial_variation_one
                  && question?.cent_aq_question_type_id !== QuestionType.interstitial
                  && question?.cent_aq_question_type_id !== QuestionType.interstitial_generic
                  && question?.cent_aq_question_type_id !== QuestionType.interstitial_variation_two
                  && question?.cent_aq_question_type_id !== QuestionType.pledge
                  && question?.cent_aq_question_type_id !== QuestionType.claim_summary) {
                  <div class="question">
                    <!-- <div [ngClass]="isAddPullClass() ? 'question-pull': null"> -->
                    <div [ngClass]="isRemovePanelClass() ? null : 'question-panel'">
                      @if (groupQuestion?.cent_aq_question_type_id === QuestionType.checkbox_slider) {
                        <div [class]="controlCssClass ? controlCssClass : 'form-group form-group--lg mb-1'">
                          <app-question-checkbox-slider
                            [question]="question" [sliderMin]="question?.min_val" [sliderMax]="question?.max_val"
                            [sliderInit]="question?.answer" [sliderStep]="question?.interval"
                            (questionAnswer)="questionAnswerController($event)">
                          </app-question-checkbox-slider>
                        </div>
                      }
                      @for (groupQuestion of group_questions; track groupQuestion) {
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.multi_select_grouped) {
                          <app-question-multiselect-grouped
                            [question]="groupQuestion"
                            (questionAnswer)="activateNextButton($event)" (navigateBack)="goToPreviousQuestion()">
                          </app-question-multiselect-grouped>
                        }
                        <!--Checkbox Select-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.multiselect
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.checkbox) {
                          <app-question-checkbox-multiple [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-checkbox-multiple>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.pills) {
                          <app-question-pill-buttons
                            [question]="groupQuestion" [isRadio]="false" [showLabel]="false" [isUploadPills]="true"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-pill-buttons>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.mini_flow) {
                          <app-question-mini-flow-controller
                            [question]="groupQuestion" [max_item_id]="'0'" (questionAnswer)="activateNextButton($event)">
                          </app-question-mini-flow-controller>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.location_add_edit) {
                          <app-question-location-edit
                            [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                          </app-question-location-edit>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.generic_miniflow_parent) {
                          <app-question-generic-miniflow-parent
                            [question]="groupQuestion" (disableButton)="enableButtonFromChild($event)"
                            (questionAnswer)="activateMiniflowNext($event)">
                          </app-question-generic-miniflow-parent>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.odometer_reading) {
                          <app-question-odometer-reading
                            [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                          </app-question-odometer-reading>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.vehicle_damage_images) {
                          <app-question-images-of-damage
                            [question]="groupQuestion" [showLabel]="false" (questionAnswer)="activateNextButton($event)">
                          </app-question-images-of-damage>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.uploader_variation_one) {
                          <app-question-uploader-variation-one
                            [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                          </app-question-uploader-variation-one>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.parent_question_variation_one) {
                          <app-question-parent-variation-one
                            [question]="groupQuestion" [showLabel]="false"
                            [showSkip]="session_details?.superflow_id === SuperFlow.personal_claim"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-parent-variation-one>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.parent_question_variation_two) {
                          <app-question-parent-variation-two
                            [question]="groupQuestion" (parentQuestionAnswer)="activateNextButtonFromParent($event)">
                          </app-question-parent-variation-two>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.or_control) {
                          <app-question-or-control
                            [question]="groupQuestion" (parentQuestionAnswer)="activateNextButtonFromParent($event)">
                          </app-question-or-control>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.radio_column_parent) {
                          <app-question-radio-column-parent
                            [showLabel]="false"
                            [question]="groupQuestion" (parentQuestionAnswer)="activateNextButtonFromParent($event)">
                          </app-question-radio-column-parent>
                        }
                        <!--Question Product Select-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.product_select) {
                          <app-question-product-select
                            [question]="groupQuestion" (questionAnswer)="submitOption($event)" (navigateBack)="goToPreviousQuestion()">
                          </app-question-product-select>
                        }
                        <!--Question Multi Select-->
                        @if (question?.cent_aq_question_type_id === QuestionType.multiselect_items) {
                          <app-question-multiselect-items
                            [question]="groupQuestion" [readonly]="readonly" (questionAnswer)="activateNextButton($event)">
                          </app-question-multiselect-items>
                        }
                        <!--Question Witness Details-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.witness_details) {
                          <app-question-witness-details
                            [question]="groupQuestion" [readonly]="readonly" (questionAnswer)="activateNextButton($event)">
                          </app-question-witness-details>
                        }
                        <!--Question Toggle Button-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.toggle) {
                          <app-question-toggle-button [question]="groupQuestion" [readonly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-toggle-button>
                        }
                        <!--Question Radio button-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.radio) {
                          <app-question-radio [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-radio>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.yes_no) {
                          <app-question-yes-no
                            [question]="groupQuestion" [readOnly]="readonly" [showLabel]="false"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-yes-no>
                        }
                        <!--Question Radio Form-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.radio_form) {
                          <app-question-radio-form
                            [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-radio-form>
                        }
                        <!--Question Mini Flow Sidesheet-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.mini_flow_sidesheet) {
                          <app-question-mini-flow-sidesheet
                            [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-mini-flow-sidesheet>
                        }
                        <!--Question UW Modal-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.uw_modal) {
                          <app-question-uw-modal
                            [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-uw-modal>
                        }
                        <!--Question CSV Upload-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.csv_upload) {
                          <app-question-csv-upload
                            [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-csv-upload>
                        }
                        <!--Question Sample New Type-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.sample_new_type) {
                          <app-question-sample
                            [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-sample>
                        }
                        <!--Question Slider-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.slider_si
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.slider_excess) {
                          <app-question-slider-parent [question]="groupQuestion"
                            [readOnly]="readonly" [isExcessSlider]="groupQuestion?.cent_aq_question_type_id === QuestionType.slider_excess"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-slider-parent>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.slider_generic) {
                          <app-question-slider-generic [question]="groupQuestion"
                            [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-slider-generic>
                        }
                        <!--Question Textbox-->
                        @if ( (groupQuestion?.cent_aq_question_type_id === QuestionType.textbox && !groupQuestion?.parent_control)
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.passport
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.id_number
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.other_id_number) {
<app-question-textbox [question]="groupQuestion" [readOnly]="readonly" [isIdInput]="groupQuestion?.cent_aq_question_type_id === QuestionType.id_number ||
                      groupQuestion?.cent_aq_question_type_id === QuestionType.other_id_number"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-textbox>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.year) {
                          <app-question-year [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-year>
                        }
                        <!--Question Tel-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.tel) {
                          <app-question-tel [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-tel>
                        }
                        <!--Question Currency-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.currency
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.currency_readonly) {
                          <app-question-currency [question]="groupQuestion"
                            [readOnly]="groupQuestion?.cent_aq_question_type_id === QuestionType.currency_readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-currency>
                        }
                        @if (question?.cent_aq_question_type_id === QuestionType.super_vaps_control) {
                          <app-question-super-vaps-control
                            [question]="question"
                            [readOnly]="question?.edit === 0"
                            [showLabel]="showLabel"
                            (questionAnswer)="activateNextButton($event)"
                            >
                          </app-question-super-vaps-control>
                        }
                        <!--Question Percentage Textbox-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.textbox_percentage) {
                          <app-question-percentage-textbox [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-percentage-textbox>
                        }
                        <!--Question Number Textbox-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.number) {
                          <app-question-number-textbox [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-number-textbox>
                        }
                        <!--Question Company Registration Input-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.registration_number) {
                          <app-question-company-registration [question]="groupQuestion" [readOnly]="readonly"  [showLabel]="false"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-company-registration>
                        }
                        <!--Question Address-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.location) {
                          <app-question-location [question]="groupQuestion" [readonly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-location>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.address) {
                          <app-question-address [question]="groupQuestion" [readOnly]="false" [showLabel]="false"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-address>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.address_textbox) {
                          <app-question-address-textbox [question]="groupQuestion" [readOnly]="false" [showLabel]="false"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-address-textbox>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.verify_email) {
                          <app-question-verify-email
                            [question]="groupQuestion" [readOnly]="false" [showLabel]="false" [clearValues]="clearEmailAddress"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-verify-email>
                        }
                        <!--Question Dropdown-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.dropdown) {
                          <app-question-dropdown [readOnly]="readonly" [useUiFront]="true" [question]="groupQuestion"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-dropdown>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.dropdown_currency) {
                          <app-question-dropdown-currency [readOnly]="readonly" [question]="groupQuestion"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-dropdown-currency>
                        }
                        <!--Question Select Button-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.select_button) {
                          <app-question-select-button [readonly]="readonly" [question]="groupQuestion"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-select-button>
                        }
                        <!--Question Checkbox Image-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.checkbox_image) {
                          <app-question-checkbox-image [readOnly]="readonly" [question]="groupQuestion" [isEmergency]="isEmergency"
                            (questionAnswer)="activateNextButton($event)" (openModal)="openEmergencyServiceModal($event)">
                          </app-question-checkbox-image>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.checkbox_miniform) {
                          <app-question-checkbox-miniform [readOnly]="readonly" [question]="groupQuestion" [isEmergency]="isEmergency"
                            (questionAnswer)="activateNextButton($event)" (openModal)="openEmergencyServiceModal($event)">
                          </app-question-checkbox-miniform>
                        }
                        <!--Question Textbox Autocomplete-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.vehicle_make
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.vehicle_model
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.vehicle_year
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.industry
                          || groupQuestion?.cent_aq_question_type_id === QuestionType.profession) {
                          <app-question-autocomplete [question]="groupQuestion"
                            [readOnly]="readonly"
                            [inputType]="groupQuestion?.cent_aq_question_type_id === QuestionType.vehicle_year ? 'number' : 'text'"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-autocomplete>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.checkbox_search_list) {
                          <app-question-checkbox-search-list
                            [question]="groupQuestion"
                            [readOnly]="readonly"
                            [inputType]="groupQuestion?.cent_aq_question_type_id === QuestionType.vehicle_year ? 'number' : 'text'"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-checkbox-search-list>
                        }
                        <!--Question Textbox Autocomplete Generic-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.autocomplete_generic) {
                          <app-question-autocomplete-generic
                            [question]="groupQuestion"
                            [readOnly]="readonly" [inputType]="'text'" (questionAnswer)="activateNextButton($event)">
                          </app-question-autocomplete-generic>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.vehicle_details) {
                          <app-question-vehicle-make-year-model
                            [question]="groupQuestion" [readOnly]="readonly" (questionAnswer)="activateNextButton($event)">
                          </app-question-vehicle-make-year-model>
                        }
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.industry_occupation) {
                          <app-question-industry-occupation
                            [question]="groupQuestion" [readOnly]="readonly" (questionAnswer)="activateNextButton($event)">
                          </app-question-industry-occupation>
                        }
                        <!--Question Plus Minus-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.plus_minus) {
                          <app-question-plus-minus [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-plus-minus>
                        }
                        <!--Question Min Max Textbox-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.min_max_textbox) {
                          <app-question-min-max-textbox [question]="groupQuestion" [readOnly]="readonly"
                            (questionAnswer)="activateNextButton($event)">
                          </app-question-min-max-textbox>
                        }
                        <!--Question Square Meter-->
                        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.rebuild_cost) {
                          <app-question-rebuild-cost
                            [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                          </app-question-rebuild-cost>
                        }
                        <!--Question All Risk List-->
                        <!--<app-question-specified-items
                        #childRiskList
                        *ngIf="groupQuestion?.cent_aq_question_type_id === QuestionType.allrisk_list"
                        [question]="groupQuestion"
                        (questionAnswer)="activateNextButton($event)">
                      </app-question-specified-items>-->
                      <!--Question Text Area-->
                      @if (groupQuestion?.cent_aq_question_type_id === QuestionType.textarea) {
                        <app-question-textarea [question]="groupQuestion" [readonly]="readonly"
                          (questionAnswer)="activateNextButton($event)">
                        </app-question-textarea>
                      }
                      <!--Question Radio Image-->
                      @if (groupQuestion?.cent_aq_question_type_id === QuestionType.radio_image) {
                        <app-question-radio-image-details [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                        </app-question-radio-image-details>
                      }
                      <!--Question Radio Image-->
                      @if (groupQuestion?.cent_aq_question_type_id === QuestionType.radio_icon) {
                        <app-question-radio-icons [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                        </app-question-radio-icons>
                      }
                      @if (groupQuestion?.cent_aq_question_type_id === QuestionType.reg_vin) {
                        <app-question-reg-vin [question]="groupQuestion" (parentQuestionAnswer)="activateNextButtonFromParent($event)">
                        </app-question-reg-vin>
                      }
                      @if (groupQuestion?.cent_aq_question_type_id === QuestionType.selector) {
                        <app-question-selector
                          [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                        </app-question-selector>
                      }
                      <!--<app-question-radio-icons
                      *ngIf="question?.cent_aq_question_type_id === QuestionType.radio_image"
                      [question]="question"
                      [readOnly]="readonly"
                      (questionAnswer)="activateNextButton($event)">
                    </app-question-radio-icons>-->
                    <!--Question Vehicle Risk List-->
                    <!--<app-question-vehicle-risk-list
                    #childRiskList
                    *ngIf="groupQuestion?.cent_aq_question_type_id === QuestionType.vehicle_list"
                    [question]="groupQuestion"
                    (questionAnswer)="activateNextButton($event)">
                  </app-question-vehicle-risk-list>-->
                  <!--Question Label Amount-->
                  <!--<app-question-label-amount-parent
                  *ngIf="groupQuestion?.cent_aq_question_type_id === QuestionType.label_amount_parent"
                  [question]="groupQuestion"
                  (questionAnswer)="activateNextButton($event)">
                </app-question-label-amount-parent>-->
                <!--Question Toggle Parent-->
                @if (groupQuestion?.cent_aq_question_type_id === QuestionType.toggle_parent) {
                  <app-question-toggle-parent
                    [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                  </app-question-toggle-parent>
                }
                <!--Question Date Picker-->
                @if (groupQuestion?.cent_aq_question_type_id === QuestionType.date) {
                  <app-question-date-picker
                    [question]="groupQuestion" [numberMonths]="1" (questionAnswer)="activateNextButton($event)">
                  </app-question-date-picker>
                }
                <!--Multiple Date Selector-->
                @if (groupQuestion?.cent_aq_question_type_id === QuestionType.start_end_date) {
                  <app-question-multiple-date-picker [question]="groupQuestion" [numberMonths]="1"
                    (questionAnswer)="activateNextButton($event)">
                  </app-question-multiple-date-picker>
                }
                <!--Question Time Picker-->
                @if (groupQuestion?.cent_aq_question_type_id === QuestionType.time) {
                  <app-question-timepicker
                    [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                  </app-question-timepicker>
                }
                @if (groupQuestion?.cent_aq_question_type_id === QuestionType.quote_screen) {
                  <app-question-quote
                    [question]="groupQuestion" (questionAnswer)="activateNextButton($event)" (submitResponse)="submitResponse()" (navigateBack)="goToPreviousQuestion()">
                  </app-question-quote>
                }
                @if (groupQuestion?.cent_aq_question_type_id === QuestionType.quote_pay) {
                  <app-question-quote-pay [ngClass]="isRemovePanelClass() ? 'question-note--detached' : null"
                    [question]="groupQuestion" (questionAnswer)="activateNextButton($event)" (submitResponse)="submitResponse()" (navigateBack)="goToPreviousQuestion()">
                  </app-question-quote-pay>
                }
                <!--Question Family List-->
                <!--<app-question-family-list
                #childRiskList
                *ngIf="groupQuestion?.cent_aq_question_type_id === QuestionType.family_list"
                [question]="groupQuestion"
                (questionAnswer)="activateNextButton($event)">
              </app-question-family-list>-->
              <!--Question Item List-->
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.family_list
                || groupQuestion?.cent_aq_question_type_id === QuestionType.allrisk_list
                || groupQuestion?.cent_aq_question_type_id === QuestionType.vehicle_list
                || groupQuestion?.cent_aq_question_type_id === QuestionType.list) {
                <app-question-items-list #childRiskList [question]="groupQuestion"
                  (showAddAnotherButton)="showAddAnother = $event;" (questionAnswer)="activateNextButton($event)">
                </app-question-items-list>
              }
              <!--Question Date of Birth-->
              @if (groupQuestion.cent_aq_question_type_id === QuestionType.dob) {
                <app-question-date-of-birth [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                </app-question-date-of-birth>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.label_amount_parent ||
                groupQuestion?.cent_aq_question_type_id === QuestionType.label_perc_parent ||
                groupQuestion?.cent_aq_question_type_id === QuestionType.textbox_amount_parent ||
                groupQuestion?.cent_aq_question_type_id === QuestionType.textbox_perc_parent) {
                <app-question-label-textbox-parent
                  [question]="groupQuestion"
                  [showHeaderTotal]="false"
                  [showFooterTotal]="false"
                  [showDelete]="false"
                  [isEditModal]="false"
                [isPercentage]="groupQuestion?.cent_aq_question_type_id === QuestionType.label_perc_parent ||
                      groupQuestion?.cent_aq_question_type_id === QuestionType.textbox_perc_parent"
                  (parentQuestionAnswer)="activateNextButtonFromParent($event)"
                  (questionAnswer)="activateNextButton($event)">
                </app-question-label-textbox-parent>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.label_amount_json) {
                <app-question-label-amount-json
                  [question]="groupQuestion" [showHeader]="true" [showHeaderTotal]="false" [showFooterTotal]="false"
                  [showDelete]="false" (questionAnswer)="activateNextButton($event)">
                </app-question-label-amount-json>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.label_percent_json) {
                <app-question-label-percent-json
                  [question]="groupQuestion"
                  [showHeader]="true" [showHeaderTotal]="false" [showFooterTotal]="false" [showDelete]="false"
                  (questionAnswer)="activateNextButton($event)">
                </app-question-label-percent-json>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.funeral_policy_member) {
                <app-question-funeral-policy-member
                  [question]="groupQuestion"
                  [showHeader]="true" [showHeaderTotal]="false" [showFooterTotal]="false" [showDelete]="false"
                  (questionAnswer)="activateNextButton($event)">
                </app-question-funeral-policy-member>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.multi_dropdown_perc) {
                <app-question-multi-dropdown-perc
                  [question]="groupQuestion"
                  [showHeader]="true" [showHeaderTotal]="false" [showFooterTotal]="false" [showDelete]="true"
                  (questionAnswer)="activateNextButton($event)">
                </app-question-multi-dropdown-perc>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.generic_parent) {
                <app-question-generic-parent
                  [question]="groupQuestion" [showHeader]="true" [showHeaderTotal]="true" [showFooterTotal]="false"
                  [showDelete]="false" (enableButtonFromChild)="enableButtonFromChild($event)"
                  (childTypePresence)="onGenericParentChildTypePresence($event)"
                  (questionAnswer)="activateNextButton($event)">
                </app-question-generic-parent>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.generic_parent_stacked) {
                <app-question-generic-parent-stacked
                  [question]="groupQuestion" (enableButtonFromChild)="enableButtonFromChild($event)"
                  (childTypePresence)="onGenericParentChildTypePresence($event)"
                  (questionAnswer)="activateNextButton($event)">
                </app-question-generic-parent-stacked>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.traffic_cop) {
                <app-question-traffic-cop
                  [question]="groupQuestion" [showHeader]="true" [showHeaderTotal]="true" [showFooterTotal]="false"
                  [showDelete]="false" (showEditModal)="showEditModal($event)"
                  [enableButtonFromChild]="enableButtonFromChild($event)" (questionAnswer)="activateNextButton($event)">
                </app-question-traffic-cop>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.traffic_cop_2) {
                <app-question-traffic-cop-2
                  [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                </app-question-traffic-cop-2>
              }
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.super_traffic_cop) {
                <app-question-super-traffic-cop
                  [question]="groupQuestion" [showHeader]="true" [showHeaderTotal]="true" [showFooterTotal]="false"
                  [showDelete]="false" [selectedLocation]="selectedLocation" (showEditModal)="showEditModal($event)"
                  (enableButtonFromChild)="enableButtonFromChild($event)" (questionAnswer)="activateNextButton($event)"
                  (submit)="submitResponse()"
                  (locationExits)="loadLocations($event)">
                </app-question-super-traffic-cop>
              }
              <!--Question Uploaders-->
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.upload) {
                <app-question-upload [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                </app-question-upload>
              }
              <!--Question Uploaders-->
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.upload_images) {
                <app-question-uploaders-images [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                </app-question-uploaders-images>
              }
              <!--Question Uploaders-->
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.upload_videos) {
                <app-question-uploaders-videos [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                </app-question-uploaders-videos>
              }
              <!--Question Uploaders-->
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.upload_selfie) {
                <app-question-uploaders-selfie [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                </app-question-uploaders-selfie>
              }
              <!--Question Uploaders-->
              @if (groupQuestion?.cent_aq_question_type_id === QuestionType.upload_documents) {
                <app-question-uploaders-documents [question]="groupQuestion" (questionAnswer)="activateNextButton($event)">
                </app-question-uploaders-documents>
              }
            }
          </div>
          <!--Question Note-->
          @if (group_questions?.length && question?.cent_aq_question_type_id === QuestionType.quote_loader === false
            && question?.cent_aq_question_type_id !== QuestionType.quote_screen) {
            <!--
            no comment state
            The question-note--detached class should only be used in certain cases - mostly where the white question-panel does not exist, but may need to be added in certain other cases
            -->
            @if (!group_questions[0]?.comment) {
              <div class="question-note" [ngClass]="isRemovePanelClass() ? 'question-note--detached' : null">
                <div class="question-note__icon">
                  <svg class="icon icon--sm text-color-core">
                    <use xlink:href="#note"></use>
                  </svg>
                </div>
                <div class="question-note__content">
                  <p>
                    <a href="javascript:void(0);" (click)="addNoteModalComponent.showModal(group_questions[0]);">
                      <small class="font-medium">Add an optional note</small>
                    </a>
                  </p>
                </div>
              </div>
            }
            <!-- comment exists state
            same question-note--detached logic applies as above
            -->
            @if (group_questions[0]?.comment) {
              <div class="question-note" [ngClass]="isRemovePanelClass() ? 'question-note--detached' : null">
                <div class="question-note__icon">
                  <svg class="icon icon--sm text-color-core">
                    <use xlink:href="#note-filled"></use>
                  </svg>
                </div>
                <div class="question-note__content">
                  <p>
                    <small id="demo-added-a-note-content">{{ group_questions[0]?.comment }}</small>
                  </p>
                  <div class="question-note__actions">
                    <a href="javascript:void(0);" (click)="addNoteModalComponent.showModal(group_questions[0]);"><small class="font-medium">Edit note</small></a>
                    <a href="javascript:void(0);" (click)="deleteNote()" class="text-color-error"><small class="font-medium">Delete note</small></a>
                  </div>
                </div>
              </div>
            }
          }
          @if (itk) {
            <div class="itk mt-pageMargin">
              <div class="itk__items">
                <div class="itk__item">
                  <div class="itk__item-icon">
                    <img src="/assets/0/favicon/favicon-black.svg" class="icon icon--sm" />
                  </div>
                  <div class="itk__item-content" [innerHTML]="'<strong>Important to know</strong> ' + (itk || '')"></div>
                </div>
              </div>
            </div>
          }
        </div>
      }
      <!-- /.question -->
      @for (groupQuestion of group_questions; track groupQuestion) {
        @if (groupQuestion?.cent_aq_question_type_id === QuestionType.quote_loader) {
          <app-question-quote-loader
            [question]="groupQuestion" (questionAnswer)="activateNextButton($event)" (submitResponse)="submitResponse()">
          </app-question-quote-loader>
        }
      }
      @if (
        question?.cent_aq_question_type_id !== QuestionType.product_select &&
        question?.cent_aq_question_type_id !== QuestionType.quote_screen &&
        question?.cent_aq_question_type_id !== QuestionType.quote_loader &&
        question?.cent_aq_question_type_id !== QuestionType.quote_pay
        ) {
        <div class="question-nav">
          @if (question?.cent_aq_question_type_id !== QuestionType.claim_summary
            && question?.cent_aq_question_type_id !== QuestionType.summary
            ) {
            <div class="question-nav__back">
              <!-- back button -->
              <button class="button button--back"  title="Back" (click)="goToPreviousQuestion()">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </button>
            </div>
          }
          <div class="question-nav__btns">
            <!-- add another button -->
            @if ((question?.cent_aq_question_type_id === QuestionType.vehicle_list
              || question?.cent_aq_question_type_id === QuestionType.allrisk_list
              || question?.cent_aq_question_type_id === QuestionType.family_list
              || question?.cent_aq_question_type_id === QuestionType.list
              || question?.cent_aq_question_type_id === QuestionType.claim_summary) && showAddAnother) {
              <button class="button button--lg button--secondary"
              (click)="addAnother()">Add Another</button>
            }
            <!-- continue/register claim button-->
            @if (question?.cent_aq_question_type_id !== QuestionType.super_traffic_cop) {
              <button class="button button--lg button--primary"
                (click)="submitResponse()"
                [attr.disabled]="disabledButton ? true : null"
                id="next-question">
                @if (question?.cent_aq_question_type_id !== QuestionType.claim_summary) {
                  @if (showButtonLoading) {
                    <span class="icon">
                      <span class="spinner"></span>
                    </span>
                  }
                  Continue
                }
                @if (question?.cent_aq_question_type_id === QuestionType.claim_summary) {
                  Register Claim
                }
              </button>
            }
            <!-- quote summary button -->
            @if (question?.cent_aq_question_type_id === QuestionType.super_traffic_cop) {
              <button
                (click)="submitResponse()"
                [attr.disabled]="disabledButton ? true : null"
                class="button button--lg button--primary"
                id="next-question">
                <ng-container>
                  @if (showButtonLoading) {
                    <span class="icon">
                      <span class="spinner"></span>
                    </span>
                  }
                  <span id="next-question-label">View quote summary</span>
                </ng-container>
              </button>
            }
          </div>
        </div>
      }
      <!--Question Hint-->
    </div>
  }
  <!-- /.layout__animator -->
</div>
<!-- /.layout__main-->
<!-- same ngIf logic as .question-nav -->
@if (
  question?.cent_aq_question_type_id !== QuestionType.product_select &&
  question?.cent_aq_question_type_id !== QuestionType.quote_screen &&
  question?.cent_aq_question_type_id !== QuestionType.quote_loader &&
  question?.cent_aq_question_type_id !== QuestionType.quote_pay
  ) {
  @if (question?.cent_aq_question_type_id !== QuestionType.claim_summary
    && question?.cent_aq_question_type_id !== QuestionType.summary
    && question?.flow_index !== 1) {
    <div class="layout__back" >
      <button class="button button--back-alt" id="prev-question-alt" title="Back" (click)="goToPreviousQuestion()">
        <svg class="icon">
          <use xlink:href="#arrow-left-small"></use>
        </svg>
      </button>
    </div>
  }
}
</div>
}
<!-- <div class="loader loader--absolute" id="loader-01">
<ng-lottie [options]="options"></ng-lottie>
</div> -->
<!-- /layout -->
</main>

<app-disclaimer></app-disclaimer>

  <!-- <footer class="question-tray" *ngIf="
  question?.cent_aq_question_type_id !== QuestionType.product_select &&
  question?.cent_aq_question_type_id !== QuestionType.quote_screen &&
  question?.cent_aq_question_type_id !== QuestionType.quote_loader &&
  question?.cent_aq_question_type_id !== QuestionType.quote_pay
   ">
<div class="container">
  <div class="question-tray__controls">
        <a *ngIf="question?.cent_aq_question_type_id !== QuestionType.claim_summary
        && question?.cent_aq_question_type_id !== QuestionType.summary
        && question?.flow_index !== 1"
      href="javascript:void(0);"
      (click)="goToPreviousQuestion()"
      class="question-tray__back">
      <svg class="icon">
        <use xlink:href="#arrow-left"></use>
      </svg>
    </a>
    <div class="question-tray__btns">
      <a href="javascript:void(0);" class="button button--lg button--secondary allrisk-btn"
             *ngIf="(question?.cent_aq_question_type_id === QuestionType.vehicle_list
             || question?.cent_aq_question_type_id === QuestionType.allrisk_list
             || question?.cent_aq_question_type_id === QuestionType.family_list
             || question?.cent_aq_question_type_id === QuestionType.list
             || question?.cent_aq_question_type_id === QuestionType.claim_summary) && showAddAnother"
        (click)="addAnother()">
        <svg class="icon">
          <use xlink:href="#plus-circle-small"></use>
        </svg>
        Add Another
      </a>
      <a href="javascript:void(0);" *ngIf="question?.cent_aq_question_type_id !== QuestionType.super_traffic_cop"
        (click)="submitResponse()"
        [attr.disabled]="disabledButton ? true : null"
        class="button button--primary"
        id="next-question"
        [ngClass]="{'button--loading': showButtonLoading}">
        <ng-container *ngIf="question?.cent_aq_question_type_id !== QuestionType.claim_summary">
          <span class="button__spinner">
            <span class="spinner"></span>
          </span>
          Next
        </ng-container>

        <ng-container *ngIf="question?.cent_aq_question_type_id === QuestionType.claim_summary">
          Register Claim
        </ng-container>
      </a>
      <a href="javascript:void(0);" *ngIf="question?.cent_aq_question_type_id === QuestionType.super_traffic_cop"
        (click)="submitResponse()"
        [attr.disabled]="disabledButton ? true : null"
        class="button button--primary"
        id="next-question"
        [ngClass]="{'button--loading': showButtonLoading}">
        <ng-container>
          <span class="button__spinner">
            <span class="spinner"></span>
          </span>
          <span id="next-question-label">View quote summary</span>
        </ng-container>
      </a>
    </div>
  </div>
</div>
</footer> -->
<!-- /footer -->

<!--<app-feed-menu-desktop [question]="question"></app-feed-menu-desktop>-->
</div>

<app-summary-edit-modal #editModal [collations]="summaryCollations" [product]="summaryProduct" (questionAnswer)="activateNextButton($event)"></app-summary-edit-modal>

<app-question-add-note-modal #addNoteModalComponent (noteChanged)="noteChanged($event)"></app-question-add-note-modal>
<app-question-mini-form-modal [question]="question"  #miniFormModalComponent ></app-question-mini-form-modal>

<div class="modal fade modal--alert" id="verify-email-alert-modal" tabindex="-1" role="dialog"
  aria-labelledby="verify-email-alert-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{question?.category_id}}/avatar/happy.png" class="img-fluid"
              alt="">
            </div>
            <button class="modal-alert__close" data-dismiss="modal">
              <svg class="icon">
                <use xlink:href="#close-circle-small"></use>
              </svg>
            </button>
          </div>
        </div>

        <div class="modal-alert__content">
          <div class="container">
            <div class="rte">
              <h4>You’ve got mail</h4>
              <p>An email has been sent to <strong id="verify_email_address"></strong>. Please check your inbox for
            further instructions. If you don't see it in your inbox, remember to check your spam folder.</p>
            <p>Email verification is required for you to be able to buy online.</p>
          </div>

          <div class="modal-alert__content-btn">
            <a href="javascript:void(0);" class="button button--lg button--primary remove-dismiss" data-dismiss="modal">Okay,
            got it!</a>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>


<div class="modal fade modal--alert" id="verify-login-alert-modal" data-backdrop="static" data-keyboard="false"
  tabindex="-1" role="dialog" aria-labelledby="verify-login-alert-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{question?.category_id}}/avatar/happy.png" class="img-fluid"
              alt="">
            </div>
          </div>
        </div>

        <div class="modal-alert__content">
          <div class="container" id="verify-form">
            <div class="rte">
              <h4>Email address found!</h4>
              <p>Please sign in below so we can link this policy to your current profile on our system.</p>
            </div>

            <div class="form-group form-group--sm">
              <label>Password</label>
              <input type="password" id="verifyPassword" required name="verifyPassword" autocomplete="new-password"
                class="form-control"/>
              </div>

              <a href="javascript:void(0);" (click)="forgotPassword();">Forgot Password?</a>
              <div class="modal-alert__content-btn">
                <a href="javascript:void(0);" id="login-verify"
                  class="button button--lg button--primary remove-confirm order-last"
                (click)="LoginVerification();">Yes, please do it</a>
                <a href="javascript:void(0);" class="button button--lg button--secondary remove-dismiss"
                  (click)="clearEmail();"
                data-dismiss="modal">No, don't do it!</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade modal--alert" id="emergency-call-modal-cancel" tabindex="-1" role="dialog"
      aria-labelledby="emergency-call-modal-cancel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-alert modal-alert--alt">
          <div class="modal-alert__heading">
            <div class="container">
              <div class="modal-alert__avatar modal-alert__avatar--alt">
                <img src="assets/0/avatar/chat.png" class="img-fluid" alt="">
              </div>
            </div>
          </div>

          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <h3 class="font-normal">Are you sure you want to <strong>cancel</strong> the <strong>
                <span id="modal-assistance-product"> {{emergencyCancelItem?.answer}} </span> Assistance?</strong></h3>
                <br/>
              </div>
            </div>
          </div>

          <div class="modal-alert__button">
            <div class="container">
              <a
                href="javascript:void(0);"
                class="button button--lg button--secondary"
                data-dismiss="modal"
                (click)="undoCancelEmergencyService()">
                No, Don't Cancel
              </a>
              <a
                href="javascript:void(0);"
                id="yes-cancel"
                class="button button--lg button--primary"
                data-dismiss="modal"
                (click)="cancelEmergencyService()">
                Yes, Cancel
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade modal--alert" id="emergency-call-modal-confirm" tabindex="-1" role="dialog"
      aria-labelledby="emergency-call-modal-confirm" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content modal-alert modal-alert--alt">
          <div class="modal-alert__heading">
            <div class="container">
              <div class="modal-alert__avatar modal-alert__avatar--alt">
                <img src="assets/0/avatar/chat.png" class="img-fluid" alt="">
              </div>

            </div>
          </div>

          <div class="modal-alert__content">
            <div class="container">
              <div class="rte">
                <h3 class="font-normal">Are you sure you want to <strong>request</strong> the <strong> <span
              id="modal-confirm-assistance-product"> {{emergencyRequestItem?.answer}} </span> Assistance?</strong></h3>
              <br/>

            </div>
          </div>
        </div>

        <div class="modal-alert__button">
          <div class="container">
            <a
              href="javascript:void(0);"
              class="button button--lg button--secondary"
              data-dismiss="modal"
              (click)="undoRequestEmergencyService()">
              No, Don't Request
            </a>
            <a
              href="javascript:void(0);"
              id="yes-confirm"
              class="button button--lg button--primary"
              data-dismiss="modal"
              (click)="requestEmergencyService()">
              Yes, Request
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>


  <div class="modal fade modal--alert" id="call-us__modal" tabindex="-1" role="dialog"
    aria-labelledby="call-us__modal" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content modal-alert modal-alert--alt">

        <div class="modal-alert__heading">
          <div class="container">

            <div class="modal-alert__avatar modal-alert__avatar--alt">
              <img src="assets/0/avatar/chat.png" class="img-fluid" alt="">
            </div>

          </div>
        </div>
        <div class="modal-alert__content">
          <div class="container">
            <div class="rte">
              <h3><span class="font-light"> Bongani, we will be contacting you at:</span><br><strong>082 1234 567</strong>
            </h3>
            <p>Expect to hear from us soon.</p>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" class="button button--lg button--secondary" data-dismiss="modal">Cancel Call</a>
          <a href="javascript:void(0);" class="button button--lg button--primary" data-dismiss="modal">Okay</a>
        </div>
      </div>


    </div>
  </div>
</div>


<div class="modal fade modal--tray" id="call-us__tray" tabindex="-1" role="dialog"
  aria-labelledby="call-us__tray" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">

          <a class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#navigation-phone"></use>
            </svg>
            <div>Call us at +27 (0)87 095 2823</div>
          </a>
          <a href="#call-us__modal" class="modal-traymenu__list-item" data-toggle='modal' data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#request-call"></use>
            </svg>
            <div>Request a Call</div>
          </a>
        </div>

        <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
          <div>Close</div>
        </a>
      </div>
    </div>
  </div>
</div>


<div class="modal fade modal--alert" id="question-modal" tabindex="-1" role="dialog" aria-labelledby="prorata-modal"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--sm">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{session_details?.category_id}}/avatar/smile.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>{{question?.question_bubble?.split('|')[0]}}</h4>
            <p>{{question?.question_bubble?.split('|')[1]}}</p>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" class="button button--lg button--primary" data-dismiss="modal">Okay, got it</a>
        </div>
      </div>


    </div>
  </div>
</div>

<div class="modal fade modal--alert" id="remove-miniflowitem-modal" tabindex="-1" role="dialog"
  aria-labelledby="remove-miniflowitem-modal" style="display: none;" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{session_details?.category_id}}/avatar/unsure.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Are you sure you want to delete this item</h3>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:;" class="button button--lg button--secondary" data-toggle="modal" data-dismiss="modal">I'd
          rather not</a>
          <a href="javascript:;" (click)="globalQuestionService?.removeMiniFlowItem()" data-toggle="modal"
          data-dismiss="modal" class="button button--lg button--primary">Discard</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade modal--alert" id="remove-modal" tabindex="-1" role="dialog" aria-labelledby="restart-modal"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{session_details?.category_id}}/avatar/unsure.png" class="img-fluid" alt="">
          </div>
          <a href="javascript:void(0);" class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Are you sure?</h3>
            <p>You are about to
            remove {{ globalQuestionService?.selectedItem?.description ? globalQuestionService?.selectedItem?.description.split('|')[2] : globalQuestionService?.selectedItem?.description_1.split('|')[2] }}</p>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:;" (click)="globalQuestionService?.removeItem()"
            class="button button--lg button--secondary" data-toggle="modal"
          data-dismiss="modal">Yes, please do it</a>
          <a href="javascript:;" class="button button--lg button--primary" data-toggle="modal"
            data-dismiss="modal">No,
          please don't</a>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="modal fade modal--alert" id="remove-alert-modal" tabindex="-1" role="dialog" aria-labelledby="remove-alert-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="/assets/1/avatar/happy.png" class="img-fluid" alt="" />
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container" id="remove-alert-modal-content">
          <div class="rte text-left">

          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="#" data-toggle="modal" data-dismiss="modal" class="button button--lg button--secondary">No, keep it</a>
          <a id="remove-cover-btn" href="javascript:;" (click)="globalQuestionService?.removeSelectedCoverItem()" data-toggle="modal" data-dismiss="modal" class="button button--lg button--primary">Yes, remove it</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="splash-modal" tabindex="-1" role="dialog" aria-labelledby="splash-modal" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-tour modal-tour--max">
      <div class="modal-tour__content">
        <div id="onboarding-slider" class="modal-tour__slider">

          <div class="modal-tour__slide">
            <div class="modal-tour__img">
              <picture>
                <source media="(min-width:768px)" srcset="assets/img/onboarding/tour-commercial-flow.svg">
                <source srcset="assets/img/onboarding/tour-commercial-flow-mobile.svg">
                <img src="assets/img/onboarding/tour-commercial-flow.svg" alt="" class="img-fluid">
              </picture>
            </div>

            <h3 class="font-normal">Great! Your first <strong>location is added.</strong> Now, let's show you
            how to <strong>add the cover</strong> you need.</h3>

          </div>

        </div>
      </div>

      <div class="modal-tour__tray">
        <div class="modal-tour__tray-right">
          <a href="#" data-dismiss="modal" class="modal-tour__tray-next icon-hover icon-hover--flush">
            <svg class="icon">
              <use xlink:href="#right-small"></use>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="remove-alert-modal" tabindex="-1" role="dialog" aria-labelledby="remove-alert-modal" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="/assets/1/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte text-left">
            <h4>Hold on! If you remove [Cover Name] the following cover will also be removed:</h4>
            <ul>
              <li>[Cover Name]</li>
              <li>[Cover Name]</li>
              <li>[Cover Name]</li>
              <li>[Cover Name]</li>
              <li>[Cover Name]</li>
            </ul>
            <p>Are you sure you want to continue?</p>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="#" data-toggle="modal" data-dismiss="modal" class="button button--lg button--secondary">No,
          keep it</a>
          <a id="remove-cover-btn" href="#" data-toggle="modal" data-dismiss="modal" class="button button--lg button--primary">Yes, remove it</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="modal-discount-flow" tabindex="-1" role="dialog" aria-labelledby="modal-discount-flow" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3 [innerHTML]="discountFlow?.header"></h3>
            <p [innerHTML]="discountFlow?.body"></p>
          </div>

        </div>

      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Maybe Later</a>
          <a href="#modal-discount-mini-flow"  class="button button--lg button--primary" data-toggle="modal" data-dismiss="modal">Let’s Go</a>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="modal-discount-mini-flow" tabindex="-1" role="dialog" aria-labelledby="modal-discount-flow" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/3/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon"><use xlink:href="#close-medium"></use></svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3></h3>
            <p></p>
          </div>
          @if (discountFlow?.json_var) {
            <app-question-mini-flow-controller
              [question]="discountFlow?.json_var" [max_item_id]="'0'" (questionAnswer)="discountFlowDone($event)">
            </app-question-mini-flow-controller>
          }
        </div>

      </div>
      <!-- <div class="modal-alert__button">
      <div class="container">
        <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Maybe Later</a>
        <a href="javascript:;" (click)="startDiscountFlow()" class="button button--lg button--primary" data-dismiss="modal">Let’s Go</a>
      </div>
    </div>   -->

  </div>
</div>
</div>




